var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCorsica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5714 13.552C21.5714 10.168 18.8282 7.4248 15.4442 7.4248C12.9471 7.4248 10.8004 8.91918 9.84591 11.0619L9.09022 13.8016L9.78584 14.4972L8.39453 17.2799L9.78584 17.9755L9.09022 18.6711V19.3667L9.78584 20.0624V21.4537L10.4815 22.1493L12.5684 21.4537C12.5684 21.4537 12.5684 22.1493 13.264 22.845C13.9597 23.5406 14.6554 24.932 14.6554 24.932C14.6554 24.932 16.7423 25.6276 18.1337 23.5407C19.525 21.4537 20.9163 20.7581 20.9163 20.7581L19.5753 18.0759C20.8017 16.9557 21.5714 15.3441 21.5714 13.552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0707 15.895C24.8975 15.4182 25.3683 9.88281 25.3683 9.88281H21.4727C23.4901 14.7524 21.3785 15.0799 21.3785 15.0799C21.0925 14.8671 10.8551 10.0174 10.5306 9.89406C10.4524 9.99869 10.1646 10.2735 9.81472 11.1291C9.46478 11.9847 9.37891 12.7545 9.37891 12.7545C9.54278 12.8613 20.4148 16.6576 20.7022 16.6892C21.2725 17.0621 21.9743 18.1772 21.5821 21.4833L25.3317 20.4266C25.3318 20.4266 24.0593 17.0414 22.0707 15.895Z",
    fill: "#ACABB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCorsica);
export default __webpack_public_path__ + "static/media/flag_corsica.834ed930e658d2935f03cfd3762e6cab.svg";
export { ForwardRef as ReactComponent };